"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadBucketOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=HeadBucketOutput.js.map